import { render, staticRenderFns } from "./rewards.vue?vue&type=template&id=099e93b0&scoped=true&"
import script from "./rewards.vue?vue&type=script&lang=js&"
export * from "./rewards.vue?vue&type=script&lang=js&"
import style0 from "./rewards.vue?vue&type=style&index=0&id=099e93b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099e93b0",
  null
  
)

export default component.exports